(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_bb54d70"] && !Shopify.designMode) return;
  try {
    (() => {
  const elementName = 'fip-display-currency';
  if (customElements.get(elementName)) return;
  // Arrok v2.4 / v2.5: both the sale price and compare-at price
  // use a leaf element with the .hdt-money class.
  // .money supports other leaf price markup without touching parent wrappers.
  const priceSelector = '.hdt-money, .money';
  const currencies = [
    'USD', 'AED', 'SAR', 'KWD', 'OMR', 'BHD', 'QAR', 'DZD',
    'EUR', 'GBP', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN',
    'CZK', 'HUF', 'RON', 'ISK'
  ];
  const countryCurrencies = {
    US: 'USD', AE: 'AED', SA: 'SAR', KW: 'KWD',
    OM: 'OMR', BH: 'BHD', QA: 'QAR', DZ: 'DZD', GB: 'GBP',
    CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK',
    PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON', IS: 'ISK'
  };
  const euroCountries = [
    'AT', 'BE', 'BG', 'CY', 'DE', 'EE', 'ES', 'FI', 'FR', 'GR',
    'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PT', 'SI', 'SK'
  ];
  euroCountries.forEach(country => {
    countryCurrencies[country] = 'EUR';
  });
  const fallbackRates = {
    USD: 1, AED: 3.6725, SAR: 3.75, KWD: 0.307,
    OMR: 0.385, BHD: 0.376, QAR: 3.64, EUR: 0.92,
    GBP: 0.79, CHF: 0.88, SEK: 10.4, NOK: 10.7,
    DKK: 6.86, PLN: 3.98, CZK: 22.8, HUF: 360,
    RON: 4.58, ISK: 137, DZD: 134.48
  };
  const threeDecimalCurrencies = new Set(['KWD', 'OMR', 'BHD']);
  const zeroDecimalCurrencies = new Set(['HUF', 'ISK']);
  class FipDisplayCurrency extends HTMLElement {
    connectedCallback() {
      // Prevent duplicate listeners if Shopify reconnects the same block.
      if (this.initialized) return;
      this.initialized = true;
      this.select = this.querySelector('select');
      if (!this.select) return;
      this.rates = { ...fallbackRates };
      this.prices = new WeakMap();
      this.refreshFrame = null;
      this.active = true;
      // This block is for storefront prices whose actual shop base is USD.
      // Do not multiply non-USD base prices by USD exchange rates.
      this.baseIsUSD = (this.dataset.baseCurrency || '').toUpperCase() === 'USD';
      let savedCurrency = null;
      try {
        savedCurrency = localStorage.getItem('fip_display_currency');
      } catch (error) {
        // Browsers with disabled storage still get currency selection.
      }
      const automaticCurrency = countryCurrencies[this.dataset.country] || 'USD';
      this.select.value = currencies.includes(savedCurrency)
        ? savedCurrency
        : automaticCurrency;
      this.handleCurrencyChange = () => {
        try {
          localStorage.setItem('fip_display_currency', this.select.value);
        } catch (error) {
          // Storage is optional.
        }
        this.renderPrices();
      };
      this.select.addEventListener('change', this.handleCurrencyChange);
      this.handleVariantChange = () => this.scheduleRender();
      document.addEventListener('variant-change', this.handleVariantChange, true);
      // Track both new price nodes and updates to existing price nodes.
      // This is necessary because Arrok replaces .hdt-money nodes with outerHTML.
      this.observer = new MutationObserver(mutations => {
        if (mutations.some(mutation => this.isPriceMutation(mutation))) {
          this.scheduleRender();
        }
      });
      this.observer.observe(document.body, {
        subtree: true,
        childList: true,
        characterData: true
      });
      this.renderPrices();
      this.loadLiveRates();
    }
    disconnectedCallback() {
      this.active = false;
      this.initialized = false;
      if (this.observer) this.observer.disconnect();
      if (this.refreshFrame !== null) cancelAnimationFrame(this.refreshFrame);
      if (this.select && this.handleCurrencyChange) {
        this.select.removeEventListener('change', this.handleCurrencyChange);
      }
      if (this.handleVariantChange) {
        document.removeEventListener('variant-change', this.handleVariantChange, true);
      }
    }
    isPriceElement(node) {
      return node && node.nodeType === 1 &&
        (node.matches(priceSelector) || !!node.querySelector(priceSelector));
    }
    isPriceMutation(mutation) {
      const target = mutation.target.nodeType === 3
        ? mutation.target.parentElement
        : mutation.target;
      if (target && target.closest && target.closest(priceSelector)) return true;
      // Check newly inserted elements, including entire replacement wrappers.
      for (const node of mutation.addedNodes) {
        if (this.isPriceElement(node)) return true;
      }
      return false;
    }
    scheduleRender() {
      if (!this.active || this.refreshFrame !== null) return;
      this.refreshFrame = requestAnimationFrame(() => {
        this.refreshFrame = null;
        this.renderPrices();
      });
    }
    parseUsd(text) {
      const value = text.replace(/\u00a0/g, ' ').trim();
      if (!value) return null;
      // Never take an already-converted currency value as if it were USD.
      const foreignCodes = currencies.filter(code => code !== 'USD').join('|');
      if (new RegExp('\\b(?:' + foreignCodes + ')\\b', 'i').test(value)) return null;
      if (/[€£¥₹]/.test(value)) return null;
      // Arrok's USD money text normally looks like "$68.00" or "$1,234.50".
      const match = value.replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
      if (!match) return null;
      const amount = Number(match[0]);
      return Number.isFinite(amount) ? amount : null;
    }
    formatPrice(usdAmount) {
      const currency = this.select.value;
      const rate = this.rates[currency];
      if (!Number.isFinite(rate) || rate <= 0) return null;
      const decimals = threeDecimalCurrencies.has(currency)
        ? 3
        : zeroDecimalCurrencies.has(currency) ? 0 : 2;
      const formatted = (usdAmount * rate).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      });
      return currency === 'USD' ? '$' + formatted : currency + ' ' + formatted;
    }
    renderPrices() {
      if (!this.active || !this.select || !this.baseIsUSD) return;
      document.querySelectorAll(priceSelector).forEach(element => {
        if (element.closest('fip-display-currency')) return;
        // Only modify leaf money elements, not containers with child prices.
        if (element.querySelector(priceSelector)) return;
        const visibleText = element.textContent.trim();
        let state = this.prices.get(element);
        // If the theme changed this node's text, read a NEW original USD amount.
        // If we just changed it ourselves, keep the cached original USD amount.
        if (!state || visibleText !== state.lastRendered) {
          const originalUsd = this.parseUsd(visibleText);
          if (originalUsd === null) return;
          state = { originalUsd, lastRendered: null };
          this.prices.set(element, state);
        }
        const output = this.formatPrice(state.originalUsd);
        if (output === null) return;
        if (visibleText !== output) element.textContent = output;
        state.lastRendered = output;
      });
    }
    async loadLiveRates() {
      try {
        const response = await fetch('https://open.er-api.com/v6/latest/USD');
        if (!response.ok) return;
        const data = await response.json();
        if (!data || data.result !== 'success' || !data.rates || !this.active) return;
        const validRates = {};
        currencies.forEach(code => {
          const rate = Number(data.rates[code]);
          if (Number.isFinite(rate) && rate > 0) validRates[code] = rate;
        });
        this.rates = { ...fallbackRates, ...validRates, USD: 1 };
        this.renderPrices();
      } catch (error) {
        // The safe fallback is the approximate static USD exchange-rate table.
      }
    }
  }
  customElements.define(elementName, FipDisplayCurrency);
})();
  } catch(e) { console.error(e); }
})();

})();
